import React from 'react';
import LabelInput from '../Box/LabelInput';
import { useTranslation } from 'react-i18next';

const EnrichWithExistingAccountFields = ({
    selectedRegisteredAccountType,
    selectedAccountDetails,
    amountFxRate,
    bankConfiguration,
    walletConfiguration,
}) => {
    const { t } = useTranslation();
    const amountRateJSX = (
        <>
            <LabelInput label={t('paymentBankDetails.currency')} name='final-currency' value={selectedAccountDetails.accountCurrencycode} />
            <LabelInput label={t('paymentBankDetails.amount')} name='final-amount' value={amountFxRate.totalAmount} />
            {amountFxRate.fxRate ? <LabelInput label={t('paymentBankDetails.rate_used')} name='fx-rate-used' value={amountFxRate.fxRate} /> : null}
        </>
    );

    const bankJSX = (
        <>
            {bankConfiguration[0].clearingFormat === 'BIC' ? (
                <LabelInput label={bankConfiguration[0].clearingFormat} name='account-format' value={selectedAccountDetails.bankAccount?.bankBic} />
            ) : (
                <LabelInput
                    label={bankConfiguration[0].clearingFormat}
                    name='account-format'
                    value={selectedAccountDetails.bankAccount?.bankClearingCode}
                />
            )}
            {bankConfiguration[0].accountFormat === 'IBAN' ? (
                <LabelInput
                    label={bankConfiguration[0].accountFormat}
                    name='clearing-format'
                    value={selectedAccountDetails.bankAccount?.ibanAccountNumber}
                />
            ) : (
                <LabelInput
                    label={bankConfiguration[0].accountFormat}
                    name='clearing-format'
                    value={selectedAccountDetails.bankAccount?.accountNumber}
                />
            )}

            {selectedAccountDetails.bankAccount?.bankAccountType !== null && selectedAccountDetails.bankAccount?.bankAccountType !== '' ? (
                <LabelInput
                    label={t('paymentBankDetails.account_type')}
                    name='clearing-format'
                    value={selectedAccountDetails.bankAccount?.bankAccountType}
                />
            ) : null}
        </>
    );

    const addressJSX = (
        <>
            {selectedAccountDetails.address?.buildingNumber !== null && selectedAccountDetails.address?.buildingNumber !== '' ? (
                <LabelInput label={t('paymentBankDetails.house_flat')} name='buildingNumber' value={selectedAccountDetails.address?.buildingNumber} />
            ) : null}
            {selectedAccountDetails.address?.addressLine1 !== null && selectedAccountDetails.address?.addressLine1 !== '' ? (
                <LabelInput
                    label={t('paymentBankDetails.address_line_1')}
                    name='address-line-1'
                    value={selectedAccountDetails.address?.addressLine1}
                />
            ) : null}
            {selectedAccountDetails.address?.addressLine2 !== null && selectedAccountDetails.address?.addressLine2 !== '' ? (
                <LabelInput
                    label={t('paymentBankDetails.address_line_2')}
                    name='address-line-2'
                    value={selectedAccountDetails.address?.addressLine2}
                />
            ) : null}
            {selectedAccountDetails.address?.addressLine3 !== null && selectedAccountDetails.address?.addressLine3 !== '' ? (
                <LabelInput
                    label={t('paymentBankDetails.address_line_3')}
                    name='address-line-3'
                    value={selectedAccountDetails.address?.addressLine3}
                />
            ) : null}
            {selectedAccountDetails.address?.townName !== null && selectedAccountDetails.address?.townName !== '' ? (
                <LabelInput label={t('paymentBankDetails.town')} name='townName' value={selectedAccountDetails.address?.townName} />
            ) : null}
            {selectedAccountDetails.address?.ctrySubDivision !== null && selectedAccountDetails.address?.ctrySubDivision !== '' ? (
                <LabelInput
                    label={t('paymentBankDetails.state_country_province')}
                    name='county-subdivision'
                    value={selectedAccountDetails.address?.ctrySubDivision}
                />
            ) : null}
            {selectedAccountDetails.address?.postalCode !== null && selectedAccountDetails.address?.postalCode !== '' ? (
                <LabelInput label={t('paymentBankDetails.postal_code')} name='postal-code' value={selectedAccountDetails.address?.postalCode} />
            ) : null}
        </>
    );

    const walletJSX = (
        <>
            <LabelInput label={walletConfiguration[0].walletLabel} name='wallet-id' value={selectedAccountDetails.wallet?.walletAccountValue} />
        </>
    );
    return (
        <>
            {/*Bank Location is common in case of both Bank and Wallet*/}
            <LabelInput label={t('paymentBankDetails.bank_location')} name='bank-location' value={selectedAccountDetails.countryCode} />

            {amountRateJSX}

            {selectedRegisteredAccountType === 'bank' ? bankJSX : null}

            {selectedAccountDetails.address ? addressJSX : null}

            {selectedRegisteredAccountType === 'wallet' ? walletJSX : null}
        </>
    );
};

export default EnrichWithExistingAccountFields;
